import useGet from "../useGet";

const useCurrencies = (showDisabled = false, dependencies: any[] = []) => {
  const { value, loading } = useGet(
    `/api/Currencies?show-disabled=${showDisabled}&ts=` + new Date().getTime(),
    "Unable to read currencies",
    [],
    dependencies
  );

  return { currencies: value, currenciesLoading: loading };
};

export default useCurrencies;
